export const INSTRUCTORS_CATEGORY = 'Instructors'
export const PROGRAMS_CATEGORY = 'Programs'
export const FEATURED_CATEGORY = 'Featured'

export const MENU_CATEGORIES = [FEATURED_CATEGORY, PROGRAMS_CATEGORY]
